import { MaterialIcons } from '@expo/vector-icons';
import { Linking, StyleSheet, TouchableOpacity, View } from 'react-native';
import Toast from 'react-native-toast-message';

import { i18n } from '@/utils/i18n';

import Text from '../Text';

interface GiftShowSummaryCardProps {
  firstName: string;
  lastName: string;
  phone: string;
  textColor?: string;
}

const GiftShowSummaryCard = ({ firstName, lastName, phone, textColor = 'white' }: GiftShowSummaryCardProps) => {
  const handleSMS = async () => {
    const message = i18n.t('trb_show.gifted_sms_message');
    const smsUrl = `sms:${phone}?body=${encodeURIComponent(message)}`;

    try {
      const canOpen = await Linking.canOpenURL(smsUrl);

      if (canOpen) {
        await Linking.openURL(smsUrl);
      } else {
        Toast.show({
          type: 'error',
          text1: i18n.t('mix.sms_not_supported'),
          position: 'bottom',
          visibilityTime: 2000
        });
      }
    } catch (error) {
      console.error('Failed to send SMS:', error);
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.personRow}>
        <Text fontWeight="700" style={[{ color: textColor }, styles.fontSizeMedium]} numberOfLines={1}>
          {phone}
        </Text>
        <Text
          style={[{ color: textColor }, styles.fontSizeMedium]}
          numberOfLines={1}>{`${firstName} ${lastName}`}</Text>
      </View>
      <TouchableOpacity style={styles.smsButton} onPress={handleSMS}>
        <View style={styles.smsButtonContainer}>
          <MaterialIcons name="textsms" size={24} color="black" />
          <Text fontWeight="700" style={[{ color: 'black' }, styles.fontSizeMedium]} numberOfLines={1}>
            {i18n.t('mix.text_user')}
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  fontSizeMedium: {
    fontSize: 16
  },

  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 10
  },

  personRow: {
    flexDirection: 'row',
    gap: 20
  },

  smsButton: {
    padding: 5,
    backgroundColor: 'orange',
    borderRadius: 5
  },

  smsButtonContainer: {
    flexDirection: 'row',
    gap: 2
  }
});

export default GiftShowSummaryCard;
